// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               v7.35.1
// source: types.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Struct, Value } from "./google/protobuf/struct";

export const protobufPackage = "ag_ui";

export interface ToolCall {
  id: string;
  type: string;
  function:
    | ToolCall_Function
    | undefined;
  /**
   * Extra information, open by key. A tool call is not a message, so it carries
   * its own metadata — several can share one parent assistant message.
   */
  metadata: { [key: string]: any } | undefined;
}

export interface ToolCall_Function {
  name: string;
  arguments: string;
}

export interface InputContentDataSource {
  value: string;
  mimeType: string;
}

export interface InputContentUrlSource {
  value: string;
  mimeType?: string | undefined;
}

export interface InputContentSource {
  data?: InputContentDataSource | undefined;
  url?: InputContentUrlSource | undefined;
}

export interface TextInputPart {
  text: string;
}

export interface ImageInputPart {
  source: InputContentSource | undefined;
  metadata?: any | undefined;
}

export interface AudioInputPart {
  source: InputContentSource | undefined;
  metadata?: any | undefined;
}

export interface VideoInputPart {
  source: InputContentSource | undefined;
  metadata?: any | undefined;
}

export interface DocumentInputPart {
  source: InputContentSource | undefined;
  metadata?: any | undefined;
}

export interface InputContent {
  text?: TextInputPart | undefined;
  image?: ImageInputPart | undefined;
  audio?: AudioInputPart | undefined;
  video?: VideoInputPart | undefined;
  document?: DocumentInputPart | undefined;
}

export interface Message {
  id: string;
  role: string;
  content?: string | undefined;
  name?: string | undefined;
  toolCalls: ToolCall[];
  toolCallId?: string | undefined;
  error?: string | undefined;
  contentParts: InputContent[];
  /**
   * Extra information, open by key. See BaseEvent.metadata in events.proto for
   * why this is a Struct.
   */
  metadata:
    | { [key: string]: any }
    | undefined;
  /**
   * Which subagent produced this message, absent for the parent's own. Carried
   * per-message rather than on MessagesSnapshotEvent, since one snapshot mixes
   * the parent's messages with those of every subagent that ran.
   */
  subagentRunId?: string | undefined;
}

export interface Interrupt {
  id: string;
  reason: string;
  message?: string | undefined;
  toolCallId?: string | undefined;
  responseSchema?: any | undefined;
  expiresAt?: string | undefined;
  metadata?:
    | any
    | undefined;
  /**
   * The subagent whose work raised this interrupt; absent for a root-raised
   * interrupt.
   */
  subagentRunId?: string | undefined;
}

function createBaseToolCall(): ToolCall {
  return { id: "", type: "", function: undefined, metadata: undefined };
}

export const ToolCall: MessageFns<ToolCall> = {
  encode(message: ToolCall, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== "") {
      writer.uint32(18).string(message.type);
    }
    if (message.function !== undefined) {
      ToolCall_Function.encode(message.function, writer.uint32(26).fork()).join();
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCall {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCall();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.type = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.function = ToolCall_Function.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ToolCall>, I>>(base?: I): ToolCall {
    return ToolCall.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCall>, I>>(object: I): ToolCall {
    const message = createBaseToolCall();
    message.id = object.id ?? "";
    message.type = object.type ?? "";
    message.function = (object.function !== undefined && object.function !== null)
      ? ToolCall_Function.fromPartial(object.function)
      : undefined;
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseToolCall_Function(): ToolCall_Function {
  return { name: "", arguments: "" };
}

export const ToolCall_Function: MessageFns<ToolCall_Function> = {
  encode(message: ToolCall_Function, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.arguments !== "") {
      writer.uint32(18).string(message.arguments);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToolCall_Function {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToolCall_Function();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.arguments = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ToolCall_Function>, I>>(base?: I): ToolCall_Function {
    return ToolCall_Function.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToolCall_Function>, I>>(object: I): ToolCall_Function {
    const message = createBaseToolCall_Function();
    message.name = object.name ?? "";
    message.arguments = object.arguments ?? "";
    return message;
  },
};

function createBaseInputContentDataSource(): InputContentDataSource {
  return { value: "", mimeType: "" };
}

export const InputContentDataSource: MessageFns<InputContentDataSource> = {
  encode(message: InputContentDataSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    if (message.mimeType !== "") {
      writer.uint32(18).string(message.mimeType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputContentDataSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputContentDataSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InputContentDataSource>, I>>(base?: I): InputContentDataSource {
    return InputContentDataSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputContentDataSource>, I>>(object: I): InputContentDataSource {
    const message = createBaseInputContentDataSource();
    message.value = object.value ?? "";
    message.mimeType = object.mimeType ?? "";
    return message;
  },
};

function createBaseInputContentUrlSource(): InputContentUrlSource {
  return { value: "", mimeType: undefined };
}

export const InputContentUrlSource: MessageFns<InputContentUrlSource> = {
  encode(message: InputContentUrlSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.value !== "") {
      writer.uint32(10).string(message.value);
    }
    if (message.mimeType !== undefined) {
      writer.uint32(18).string(message.mimeType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputContentUrlSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputContentUrlSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.value = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InputContentUrlSource>, I>>(base?: I): InputContentUrlSource {
    return InputContentUrlSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputContentUrlSource>, I>>(object: I): InputContentUrlSource {
    const message = createBaseInputContentUrlSource();
    message.value = object.value ?? "";
    message.mimeType = object.mimeType ?? undefined;
    return message;
  },
};

function createBaseInputContentSource(): InputContentSource {
  return { data: undefined, url: undefined };
}

export const InputContentSource: MessageFns<InputContentSource> = {
  encode(message: InputContentSource, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      InputContentDataSource.encode(message.data, writer.uint32(10).fork()).join();
    }
    if (message.url !== undefined) {
      InputContentUrlSource.encode(message.url, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputContentSource {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputContentSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = InputContentDataSource.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.url = InputContentUrlSource.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InputContentSource>, I>>(base?: I): InputContentSource {
    return InputContentSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputContentSource>, I>>(object: I): InputContentSource {
    const message = createBaseInputContentSource();
    message.data = (object.data !== undefined && object.data !== null)
      ? InputContentDataSource.fromPartial(object.data)
      : undefined;
    message.url = (object.url !== undefined && object.url !== null)
      ? InputContentUrlSource.fromPartial(object.url)
      : undefined;
    return message;
  },
};

function createBaseTextInputPart(): TextInputPart {
  return { text: "" };
}

export const TextInputPart: MessageFns<TextInputPart> = {
  encode(message: TextInputPart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TextInputPart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextInputPart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<TextInputPart>, I>>(base?: I): TextInputPart {
    return TextInputPart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextInputPart>, I>>(object: I): TextInputPart {
    const message = createBaseTextInputPart();
    message.text = object.text ?? "";
    return message;
  },
};

function createBaseImageInputPart(): ImageInputPart {
  return { source: undefined, metadata: undefined };
}

export const ImageInputPart: MessageFns<ImageInputPart> = {
  encode(message: ImageInputPart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.source !== undefined) {
      InputContentSource.encode(message.source, writer.uint32(10).fork()).join();
    }
    if (message.metadata !== undefined) {
      Value.encode(Value.wrap(message.metadata), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImageInputPart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImageInputPart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.source = InputContentSource.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<ImageInputPart>, I>>(base?: I): ImageInputPart {
    return ImageInputPart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImageInputPart>, I>>(object: I): ImageInputPart {
    const message = createBaseImageInputPart();
    message.source = (object.source !== undefined && object.source !== null)
      ? InputContentSource.fromPartial(object.source)
      : undefined;
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseAudioInputPart(): AudioInputPart {
  return { source: undefined, metadata: undefined };
}

export const AudioInputPart: MessageFns<AudioInputPart> = {
  encode(message: AudioInputPart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.source !== undefined) {
      InputContentSource.encode(message.source, writer.uint32(10).fork()).join();
    }
    if (message.metadata !== undefined) {
      Value.encode(Value.wrap(message.metadata), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AudioInputPart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAudioInputPart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.source = InputContentSource.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<AudioInputPart>, I>>(base?: I): AudioInputPart {
    return AudioInputPart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AudioInputPart>, I>>(object: I): AudioInputPart {
    const message = createBaseAudioInputPart();
    message.source = (object.source !== undefined && object.source !== null)
      ? InputContentSource.fromPartial(object.source)
      : undefined;
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseVideoInputPart(): VideoInputPart {
  return { source: undefined, metadata: undefined };
}

export const VideoInputPart: MessageFns<VideoInputPart> = {
  encode(message: VideoInputPart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.source !== undefined) {
      InputContentSource.encode(message.source, writer.uint32(10).fork()).join();
    }
    if (message.metadata !== undefined) {
      Value.encode(Value.wrap(message.metadata), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VideoInputPart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVideoInputPart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.source = InputContentSource.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<VideoInputPart>, I>>(base?: I): VideoInputPart {
    return VideoInputPart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VideoInputPart>, I>>(object: I): VideoInputPart {
    const message = createBaseVideoInputPart();
    message.source = (object.source !== undefined && object.source !== null)
      ? InputContentSource.fromPartial(object.source)
      : undefined;
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseDocumentInputPart(): DocumentInputPart {
  return { source: undefined, metadata: undefined };
}

export const DocumentInputPart: MessageFns<DocumentInputPart> = {
  encode(message: DocumentInputPart, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.source !== undefined) {
      InputContentSource.encode(message.source, writer.uint32(10).fork()).join();
    }
    if (message.metadata !== undefined) {
      Value.encode(Value.wrap(message.metadata), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentInputPart {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentInputPart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.source = InputContentSource.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.metadata = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<DocumentInputPart>, I>>(base?: I): DocumentInputPart {
    return DocumentInputPart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DocumentInputPart>, I>>(object: I): DocumentInputPart {
    const message = createBaseDocumentInputPart();
    message.source = (object.source !== undefined && object.source !== null)
      ? InputContentSource.fromPartial(object.source)
      : undefined;
    message.metadata = object.metadata ?? undefined;
    return message;
  },
};

function createBaseInputContent(): InputContent {
  return { text: undefined, image: undefined, audio: undefined, video: undefined, document: undefined };
}

export const InputContent: MessageFns<InputContent> = {
  encode(message: InputContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.text !== undefined) {
      TextInputPart.encode(message.text, writer.uint32(10).fork()).join();
    }
    if (message.image !== undefined) {
      ImageInputPart.encode(message.image, writer.uint32(18).fork()).join();
    }
    if (message.audio !== undefined) {
      AudioInputPart.encode(message.audio, writer.uint32(26).fork()).join();
    }
    if (message.video !== undefined) {
      VideoInputPart.encode(message.video, writer.uint32(34).fork()).join();
    }
    if (message.document !== undefined) {
      DocumentInputPart.encode(message.document, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): InputContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInputContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.text = TextInputPart.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.image = ImageInputPart.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.audio = AudioInputPart.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.video = VideoInputPart.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.document = DocumentInputPart.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<InputContent>, I>>(base?: I): InputContent {
    return InputContent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InputContent>, I>>(object: I): InputContent {
    const message = createBaseInputContent();
    message.text = (object.text !== undefined && object.text !== null)
      ? TextInputPart.fromPartial(object.text)
      : undefined;
    message.image = (object.image !== undefined && object.image !== null)
      ? ImageInputPart.fromPartial(object.image)
      : undefined;
    message.audio = (object.audio !== undefined && object.audio !== null)
      ? AudioInputPart.fromPartial(object.audio)
      : undefined;
    message.video = (object.video !== undefined && object.video !== null)
      ? VideoInputPart.fromPartial(object.video)
      : undefined;
    message.document = (object.document !== undefined && object.document !== null)
      ? DocumentInputPart.fromPartial(object.document)
      : undefined;
    return message;
  },
};

function createBaseMessage(): Message {
  return {
    id: "",
    role: "",
    content: undefined,
    name: undefined,
    toolCalls: [],
    toolCallId: undefined,
    error: undefined,
    contentParts: [],
    metadata: undefined,
    subagentRunId: undefined,
  };
}

export const Message: MessageFns<Message> = {
  encode(message: Message, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.role !== "") {
      writer.uint32(18).string(message.role);
    }
    if (message.content !== undefined) {
      writer.uint32(26).string(message.content);
    }
    if (message.name !== undefined) {
      writer.uint32(34).string(message.name);
    }
    for (const v of message.toolCalls) {
      ToolCall.encode(v!, writer.uint32(42).fork()).join();
    }
    if (message.toolCallId !== undefined) {
      writer.uint32(50).string(message.toolCallId);
    }
    if (message.error !== undefined) {
      writer.uint32(58).string(message.error);
    }
    for (const v of message.contentParts) {
      InputContent.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(74).fork()).join();
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(82).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Message {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.role = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.toolCalls.push(ToolCall.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.toolCallId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.error = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.contentParts.push(InputContent.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Message>, I>>(base?: I): Message {
    return Message.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Message>, I>>(object: I): Message {
    const message = createBaseMessage();
    message.id = object.id ?? "";
    message.role = object.role ?? "";
    message.content = object.content ?? undefined;
    message.name = object.name ?? undefined;
    message.toolCalls = object.toolCalls?.map((e) => ToolCall.fromPartial(e)) || [];
    message.toolCallId = object.toolCallId ?? undefined;
    message.error = object.error ?? undefined;
    message.contentParts = object.contentParts?.map((e) => InputContent.fromPartial(e)) || [];
    message.metadata = object.metadata ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

function createBaseInterrupt(): Interrupt {
  return {
    id: "",
    reason: "",
    message: undefined,
    toolCallId: undefined,
    responseSchema: undefined,
    expiresAt: undefined,
    metadata: undefined,
    subagentRunId: undefined,
  };
}

export const Interrupt: MessageFns<Interrupt> = {
  encode(message: Interrupt, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.reason !== "") {
      writer.uint32(18).string(message.reason);
    }
    if (message.message !== undefined) {
      writer.uint32(26).string(message.message);
    }
    if (message.toolCallId !== undefined) {
      writer.uint32(34).string(message.toolCallId);
    }
    if (message.responseSchema !== undefined) {
      Value.encode(Value.wrap(message.responseSchema), writer.uint32(42).fork()).join();
    }
    if (message.expiresAt !== undefined) {
      writer.uint32(50).string(message.expiresAt);
    }
    if (message.metadata !== undefined) {
      Value.encode(Value.wrap(message.metadata), writer.uint32(58).fork()).join();
    }
    if (message.subagentRunId !== undefined) {
      writer.uint32(66).string(message.subagentRunId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Interrupt {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterrupt();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reason = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.toolCallId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.responseSchema = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.expiresAt = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.metadata = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.subagentRunId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  create<I extends Exact<DeepPartial<Interrupt>, I>>(base?: I): Interrupt {
    return Interrupt.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Interrupt>, I>>(object: I): Interrupt {
    const message = createBaseInterrupt();
    message.id = object.id ?? "";
    message.reason = object.reason ?? "";
    message.message = object.message ?? undefined;
    message.toolCallId = object.toolCallId ?? undefined;
    message.responseSchema = object.responseSchema ?? undefined;
    message.expiresAt = object.expiresAt ?? undefined;
    message.metadata = object.metadata ?? undefined;
    message.subagentRunId = object.subagentRunId ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
